/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvoucheropen2Inputs */

const en_dropvoucheropen2 = /** @type {(inputs: Dropvoucheropen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const de_dropvoucheropen2 = /** @type {(inputs: Dropvoucheropen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Dropvoucheropen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvoucheropen2 = /** @type {((inputs?: Dropvoucheropen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvoucheropen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvoucheropen2(inputs)
	return de_dropvoucheropen2(inputs)
});
export { dropvoucheropen2 as "dropVoucherOpen" }